import { timeToClockFormat } from '@shared/utils/time';
import { VehicleType } from '../models/vehicleType';
import { formatCountdown } from '@shared/utils/formatCountdown';

export function getDepartureDisplayTime(
  time: number,
  vehicleType: VehicleType,
): string {
  if (vehicleType === 'train') {
    return timeToClockFormat(time);
  }

  const difference = time - Date.now();

  if (difference >= 60 * 1000) {
    return `${formatCountdown(time)} min`;
  }

  if (difference >= 10 * 1000) {
    return `${Math.floor(difference / 10000) * 10} sek`;
  }

  return 'Nu';
}
